import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Switch from '../../../../../../../src/components/common/switch';

import capitalize from 'lodash/capitalize';
import findIndex from 'lodash/findIndex';
import truncateText from '../../../../../../../src/utils/truncate-text';

import styles from './navigation-bar.styles';

class NavigationBar extends PureComponent {

  constructor(props) {
    super(props);
    this.changeTab = this.changeTab.bind(this);
  }
  changeTab(tab, i) {
    //let assetSelectedObj = this.props.portfolio.assetSelectedObj;
    //this.props.portfolio.setAssetHeaderObj(assetSelectedObj[i]);
    this.props.setPageOffset(0);
    this.props.portfolio.setAssetClassName(tab);
    const assetList = this.props.assetList;
    const assetObj = assetList.find( x => x.assetShortDesc == tab);
    this.props.resetSort();
    this.props.portfolio.setAssetClassDesc(assetObj.assetDesc);
    this.props.portfolio.renderPage({
      path: '/portfolios/genericAssets'
    });
  }
  
  render() {
    const {
      replacePage,
      assetNames,
      portfolio: {
        assetClassName,
        setAssetClassName,
        //assetSelectedObj,
      },
      search: {
        selectedAssetClass,
      },
      messages
    } = this.props;

    let selectedIndex;
    for (var assetsRow in assetNames) {
      if (assetNames[assetsRow].class === "mmInstruments") {
        assetNames[assetsRow].name = "MM Instruments";
      } if (assetNames[assetsRow].class === "fxForwards") {
        assetNames[assetsRow].name = "FX Forwards";
      }
    }
    if (selectedAssetClass !== undefined) {
      selectedIndex = findIndex(assetNames, { class: selectedAssetClass });
      this.props.search.clearSelectedAssetClass();
    } else {
      selectedIndex = findIndex(assetNames, { class: assetClassName });
    }

    return(
      <View style={styles.root}>
        <Switch
          options={assetNames.map((assetName, i) => ({
            label: `${truncateText(assetName.name, 22)}`,
            value: i,
          }))}
          labelSize='xsmall'
          messages={messages}
          selected={selectedIndex}
          onChange={i => {
             this.props.search.clearSearchFilters();
             const tab = assetNames[i].class;
             this.changeTab(tab, i);
          }}
          align="justify"
        />
      </View>
    );
  }
}

NavigationBar.propTypes = {
  assetNames: PropTypes.arrayOf(PropTypes.shape({
    class: PropTypes.string,
    name: PropTypes.string,
  }))
};

export default createContainer({
  $queries: {
    replacePage: { $call: 'ui.history.push' },
    portfolio: {
      setAssetClassName: { $set: 'assetClassName' },
      assetClassName: true,
      //assetSelectedObj: true,
      //setAssetHeaderObj: { $set: 'selectedAssetObj'},
      setAssetClassDesc: { $set: 'selectedAssetDesc'},
      renderPage: { $call: 'reRenderPage'},
    },
    search: {
      selectedAssetClass: true,
      clearSelectedAssetClass: { $call: 'clearSearchSelectedAssetClass' },
      clearSearchFilters: { $call: 'clearFilters' },
     },
  },
})(NavigationBar);
